import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 41.1177,
			y: 4.38281,
			width: 17.7914,
			height: 20.7566,
			rx: 5.35551,
			transform: "rotate(42.7275 41.1177 4.38281)",
			fill: "url(#paint0_linear_198_9937)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 6.92007,
			y: 5.50747,
			width: 46.6398,
			height: 47.8376,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.32px)",
					clipPath: "url(#bgblur_0_198_9937_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			"data-figma-bg-blur-radius": 6.63316,
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-2-inside-1_198_9937",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M33.0708 13.0936C34.182 11.8909 36.0573 11.8166 37.2603 12.9276L45.9731 20.9754C47.1761 22.0866 47.2513 23.9628 46.1401 25.1658L29.147 43.5633C28.4177 44.3528 27.4871 44.9285 26.4556 45.2303L21.395 46.7117L13.5532 39.4686L14.6284 34.3055C14.8476 33.2534 15.3484 32.2805 16.0776 31.491L33.0708 13.0936Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.0708 13.0936C34.182 11.8909 36.0573 11.8166 37.2603 12.9276L45.9731 20.9754C47.1761 22.0866 47.2513 23.9628 46.1401 25.1658L29.147 43.5633C28.4177 44.3528 27.4871 44.9285 26.4556 45.2303L21.395 46.7117L13.5532 39.4686L14.6284 34.3055C14.8476 33.2534 15.3484 32.2805 16.0776 31.491L33.0708 13.0936Z",
					fill: "#94DCC8",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.0708 13.0936L32.3363 12.415L32.3362 12.4151L33.0708 13.0936ZM37.2603 12.9276L37.9388 12.193L37.9387 12.1929L37.2603 12.9276ZM45.9731 20.9754L45.2946 21.71L45.2946 21.71L45.9731 20.9754ZM46.1401 25.1658L46.8747 25.8444L46.8747 25.8444L46.1401 25.1658ZM29.147 43.5633L29.8815 44.2419L29.8816 44.2418L29.147 43.5633ZM26.4556 45.2303L26.1748 44.2705L26.1746 44.2706L26.4556 45.2303ZM21.395 46.7117L20.7165 47.4463L21.1325 47.8306L21.676 47.6715L21.395 46.7117ZM13.5532 39.4686L12.5742 39.2647L12.4588 39.819L12.8747 40.2032L13.5532 39.4686ZM14.6284 34.3055L13.6494 34.1015L13.6494 34.1016L14.6284 34.3055ZM16.0776 31.491L15.3431 30.8125L15.343 30.8125L16.0776 31.491ZM33.0708 13.0936L33.8053 13.7722C34.5417 12.9751 35.7845 12.9259 36.5818 13.6622L37.2603 12.9276L37.9387 12.1929C36.3302 10.7074 33.8222 10.8066 32.3363 12.415L33.0708 13.0936ZM37.2603 12.9276L36.5817 13.6622L45.2946 21.71L45.9731 20.9754L46.6517 20.2408L37.9388 12.193L37.2603 12.9276ZM45.9731 20.9754L45.2946 21.71C46.0923 22.4467 46.1417 23.6904 45.4055 24.4873L46.1401 25.1658L46.8747 25.8444C48.3609 24.2353 48.26 21.7264 46.6517 20.2408L45.9731 20.9754ZM46.1401 25.1658L45.4056 24.4873L28.4124 42.8848L29.147 43.5633L29.8816 44.2418L46.8747 25.8444L46.1401 25.1658ZM29.147 43.5633L28.4124 42.8848C27.8065 43.5407 27.0329 44.0195 26.1748 44.2705L26.4556 45.2303L26.7364 46.1901C27.9413 45.8375 29.0289 45.1649 29.8815 44.2419L29.147 43.5633ZM26.4556 45.2303L26.1746 44.2706L21.1141 45.752L21.395 46.7117L21.676 47.6715L26.7365 46.19L26.4556 45.2303ZM21.395 46.7117L22.0735 45.9772L14.2317 38.734L13.5532 39.4686L12.8747 40.2032L20.7165 47.4463L21.395 46.7117ZM13.5532 39.4686L14.5322 39.6725L15.6074 34.5094L14.6284 34.3055L13.6494 34.1016L12.5742 39.2647L13.5532 39.4686ZM14.6284 34.3055L15.6074 34.5095C15.7897 33.6347 16.2061 32.8258 16.8122 32.1696L16.0776 31.491L15.343 30.8125C14.4908 31.7352 13.9056 32.8722 13.6494 34.1015L14.6284 34.3055ZM16.0776 31.491L16.8122 32.1696L33.8054 13.7721L33.0708 13.0936L32.3362 12.4151L15.3431 30.8125L16.0776 31.491Z",
					fill: "url(#paint1_linear_198_9937)",
					mask: "url(#path-2-inside-1_198_9937)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -.174937,
			y: .00694208,
			width: 11.6133,
			height: 2.71764,
			rx: 1.35882,
			transform: "matrix(-0.734589 -0.678512 -0.678513 0.734589 43.6646 23.0316)",
			fill: "url(#paint2_linear_198_9937)",
			fillOpacity: .9,
			stroke: "url(#paint3_linear_198_9937)",
			strokeWidth: .247594
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3948 46.7118L13.5532 39.4688L11.942 47.2058C11.7138 48.3016 12.7356 49.2453 13.8098 48.931L21.3948 46.7118Z",
			fill: "url(#paint4_linear_198_9937)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_198_9937_clip_path",
				transform: "translate(-6.92007 -5.50747)",
				children: /* @__PURE__ */ _jsx("path", { d: "M33.0708 13.0936C34.182 11.8909 36.0573 11.8166 37.2603 12.9276L45.9731 20.9754C47.1761 22.0866 47.2513 23.9628 46.1401 25.1658L29.147 43.5633C28.4177 44.3528 27.4871 44.9285 26.4556 45.2303L21.395 46.7117L13.5532 39.4686L14.6284 34.3055C14.8476 33.2534 15.3484 32.2805 16.0776 31.491L33.0708 13.0936Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_198_9937",
				x1: 56.9287,
				y1: 4.81754,
				x2: 41.1177,
				y2: 14.7611,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_198_9937",
				x1: 11.8845,
				y1: 14.61,
				x2: 37.2172,
				y2: 51.9597,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_198_9937",
				x1: -.901456,
				y1: -.198139,
				x2: 14.3779,
				y2: 5.82098,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_198_9937",
				x1: -2.00828,
				y1: .631979,
				x2: 5.18561,
				y2: 4.3908,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_198_9937",
				x1: 20.4155,
				y1: 46.0209,
				x2: 11.2788,
				y2: 46.584,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
